<div class="dragndrop-container">
    <div class="dragndrop-data-area">
        <kendo-grid
            [data]="gridData"
            [height]="600"
            width="400"
            [pageable]="pageable"
            [skip]="state.skip"
            [pageSize]="state.take"
            [rowClass]="rowCallback"
        >
            <kendo-grid-column
                *ngFor="let field of columnList"
                field="{{ field.columnId }}"
                title="{{ field.columnName }}"
                [headerStyle]="getHeaderStyles()"
                width="field.width"
            >
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>
